import React from "react";
import {connect} from "react-redux";
import {authActions, Loader, utils} from "@mc/mc-legacy";
import {withRouter} from "react-router";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import Type from "../api/gen/qsign/types/Type";
import PodepisovaniPdfViewer from "../components/PodepisovaniPdfViewer";
import QueryString from 'query-string';

/**
 * Okamžité podepsání.
 */
class OkamzitePodepsaniPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {signRequest: null, returnUrl: null};
    }

    static getUuidFromProps(props): string {
        try {
            return props.match.params.uuid
        } catch (e) {
            return null;
        }
    }

    static getReturnUrlFromLocation(location): string {
        const searchParams = QueryString.parse(location.search);
        return searchParams.returnUrl;
    }

    componentDidMount() {
       this.fetchData(this.props, true);
    }

    // UNSAFE_componentWillReceiveProps(nextProps) {
    //     this.fetchData(nextProps, false);
    // }

    fetchData = (props, forceFetch) => {
        const uuid = OkamzitePodepsaniPage.getUuidFromProps(props);
        const returnUrl = OkamzitePodepsaniPage.getReturnUrlFromLocation(props.location);
        SignRequestInternalApi.getRequestByUuid(uuid).then((res) => this.setState({signRequest: res, returnUrl: returnUrl}));
    };

    handleZobrazit = (signRequest, returnUrl) => {
        const {dispatch, history} = this.props;
        dispatch(
            pdfViewerActions.showDocuments(
                signRequest,
                false,
                Type.ALL,
                () => {
                    if (returnUrl) {
                        window.location.href = returnUrl;
                    } else {
                        history.push("/ukoly/historie");
                    }
                },
                PodepisovaniPdfViewer.VIEW_MODE.BASE,
                screen.width,
                true,
                false
            )
        );
    };

    render() {
        const {dispatch, match: {params: {uuid}}} = this.props;
        const {signRequest, returnUrl} = this.state;

        if (signRequest) {
            this.handleZobrazit(signRequest, returnUrl);
            return <div>Okamžité podepsání: {uuid}</div>;
        } else {
            return <Loader/>;
        }
    }
}

function mapStateToProps(state) {
    return {
        authInfo: utils.storeFromArea(state, authActions.AUTH_INFO_AREA),
    };
}

export default withRouter(connect(mapStateToProps)(OkamzitePodepsaniPage));
